<template>
  <div class="container-fluid container-lg bg-gray-100 mb-5 p-3">
    <router-link type="button" class="hover:underline block text-left" to="/benefitByReference">
      <svg
        class="h-8 w-8 fill-current text-blue-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15"
      >
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
        />
      </svg>
    </router-link>
    <div class="container-fluid bg-white rounded-lg p-2 box-shadow">
      <p class="text-gray-700 text-center text-2xl lg:text-3xl">
        Información Personal
      </p>

      <form
        autocomplete="off"
        @submit.prevent="onSubmit()"
        class="flex flex-wrap"
      >
        <!-- GRID INIT-->
        <div
          class="mb-4 grid gap-2 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 w-full"
        >
          <!-- CONTAINER 1 INIT-->
          <div
            class=" text-left xs:container sm:container md:container lg:container xl:container w-full flex flex-wrap"
          >
            <div class="w-full">
              <label> RFC*: </label>
              <input
                id="idDisable"
                ref="rfc"
                type="text"
                v-model="rfc"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="13"
                minlength="13"
                pattern="[a-zñA-ZÑ0-9]{13,13}"
                title="RFC debe tener 13 caracteres, sin espacios ni caracteres especiales"
                @input="toUpperCase"
                @blur="validateRFCLength"
                @change="validityRFC()"
                @keyup="validityRFC()"

                required
              />
              <span class="block text-xs text-red-500 w-full" v-if="incorrectRFC">
                RFC incorrecto
              </span>
              <span class="text-xs text-red-500 w-full" v-if="incorrectRFCLenght">
                RFC debe de ser 13 caracteres
              </span>
            </div>
            <div class="w-full">
              <label class="mt-2"> Apellido Paterno*: </label>
              <input
                type="text"
                ref="paternalLastName"
                id="paternalLastName"
                v-model="paternalLastName"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="1"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Apellido debe tener un máximo de 30 caracteres, sin caracteres especiales"
                @input="paternalLastName = $filters.capitalizeWords(paternalLastName)"
              />
              
            </div>

            <div class="w-full">
              <label class="mt-2"> Apellido Materno: </label>
              <input
                type="text"
                ref="maternalLastName"
                id="maternalLastName"
                v-model="maternalLastName"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="1"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Apellido debe tener un máximo de 30 caracteres, sin caracteres especiales"
                @input="maternalLastName = $filters.capitalizeWords(maternalLastName)"
              />
            </div>

            <div class="w-full">
              <label class="mt-2"> Nombre*: </label>
              <input
                type="text"
                ref="name"
                id="nombre"
                v-model="name"
                class="capitalize w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="2"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Nombre debe tener un máximo de 30 caracteres, sin caracteres especiales"
                @input="name =$filters.capitalizeWords(name)"
                @focusout="validateRFCWithNames()"
                
                required
              />
              
            </div>
            <!--<div class="w-full">
              <label class="mt-5 mb-2"> Delegación Sindical: </label>
              <input
                type="text"
                v-model="delegation"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="6"
                minlength="6"
                pattern="[0-9-a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,6}"
                title="Calle debe tener de 6 caracteres, sin caracteres especiales"
                oninput="this.value = this.value.toUpperCase();"
              />
            </div>
            <div class="w-full">
              <label> Estatus: </label>
              <v-select
                v-model="selectedStatus"
                class="appearance-none rounded text-grey-darker w-full shadow"
                :options="selectStatus"
                :placeholder="'Seleccione un estatus'"
                :required="statusSelected"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
              <span v-if="statusSelected" class="text-red-600 text-xs"
                >Seleccione un estatus</span
              >
            </div> -->
            <div class="sm:inline-flex">
              <div class="">
                <label class="w-full"> Estatus*: </label>
                <b-form-group
                  class="sm:text-center lg:text-left xl:text-left w-full"
                >
                  <b-form-radio-group
                    id="btn-radios-status"
                    v-model="status"
                    :options="optionsStatus"
                    buttons
                    button-variant="outline-primary"
                    size="sm"
                    name="radio-btn-stacked"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <span v-if="statusSelected" class="text-red-600 text-xs"
                  >Seleccione un estatus</span
                >
              </div>
            </div>
            <div class="w-full">
              <label class="w-full"> Base: </label>
              <v-select
              :searchable="false"
                v-model="selectedBase"
                class="appearance-none rounded text-grey-darker w-full shadow-sm"
                :options="selectBase"
                :placeholder="'Seleccione una base'"
                :required="!selectedBase"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
              <span v-if="baseSelected" class="text-red-600 text-xs"
                >Seleccione una base</span
              >
            </div>
            <div class="sm:inline-flex">
              <div class="">
                <label class="mt-2 w-full"> Género*: </label>

                <b-form-group
                  class="sm:text-center lg:text-left xl:text-left w-full"
                >
                  <b-form-radio-group
                    id="btn-radios-gender"
                    v-model="gender"
                    :options="optionsGender"
                    buttons
                    button-variant="outline-primary"
                    size="sm"
                    name="radio-btn-stacked"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <span v-if="genderSelected" class="text-red-600 text-xs"
                  >Seleccione un género</span
                >
              </div>
            </div>
            <div class="w-full">
              <label class="mb-2 w-full"> Estado Civil*: </label>
              <p
                v-if="!maritalStatusVisible"
                class="semi-bold sm:ml-24 mb-16 text-sm"
              >
                {{ this.maritalStatus }}
              </p>
              <b-form-group
                v-show="maritalStatusVisible"
                class="sm:text-center lg:text-left xl:text-left w-full"
              >
                <b-form-radio-group
                  id="btn-radios"
                  v-model="maritalStatus"
                  :options="optionsMaritalStatus"
                  buttons
                  button-variant="outline-primary"
                  size="sm"
                  name="radio-btn-stacked"
                  select="Titular"
                >
                </b-form-radio-group>
              </b-form-group>

              <b-form-group
                v-show="maritalStatusVisible"
                class="sm:text-center lg:text-left xl:text-left -mt-4 lg:-mt-5 xl:-mt-5 w-full"
              >
                <b-form-radio-group
                  id="btn-radios-2"
                  v-model="maritalStatus"
                  :options="optionsMaritalStatus2"
                  buttons
                  button-variant="outline-primary"
                  size="sm"
                  name="radio-btn-stacked"
                >
                </b-form-radio-group>
              </b-form-group>
              <div class="-mt-5">
                <span v-if="maritalStatusSelected" class="text-red-600 text-xs"
                  >Seleccione un estado civil</span
                >
              </div>
            </div>
            <div class="w-full" v-if="section == 'Seccion 54'">
              <label class="mt-5 mb-2"> Número de Pensión: </label>
              <input
                type="number"
                v-model="pension_number"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                max="99999"
                min="2"
                pattern="{1,10}"
                title="Número de Pensión debe tener un máximo de 10 caracteres, sin caracteres especiales"
              />
            </div>
            <!--<div class="w-full">
              <label> Tipo de Jubilación: </label>
              <v-select
                v-model="selectedRetirement_type"
                class="appearance-none rounded text-grey-darker w-full shadow"
                :options="selectRetirement_type"
                :placeholder="'Seleccione un tipo de jubilación'"
                :required="!selectedRetirement_type"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
            </div>-->
          </div>
          <!-- CONTAINER 1 END-->

          <!-- CONTAINER 2 INIT-->
          <div
            class="text-left  xs:container sm:container md:container lg:container xl:container sm:h-0 md:h-0 lg:h-0 xl:h-0 w-full flex-wrap"
          >
            <div class="w-full">
              <label> Calle*: </label>
              <input
                id="input_street"
                type="text"
                v-model="street"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="2"
                pattern="[0-9-a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Calle debe tener un máximo de 30 caracteres, sin caracteres especiales"
                oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
                required
              />
            </div>

            <div class="w-full grid grid-cols-2 gap-2">
              <div class="w-full">
                <label class="mb-2 mt-2">
                  Número exterior*:
                  <input
                    id="input_outdoor_number"
                    type="text"
                    v-model="externalNumber"
                    class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                    maxlength="5"
                    minlength="2"
                    pattern="(S\/n)?(S/N)?([0-9]{1,20})?"
                    title="Número exterior debe tener un máximo de 20 caracteres, sólo números."
                    oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
                    required
                    @blur="validityExternalNumber()"
                    @change="validityExternalNumber()"
                    @keyup="validityExternalNumber()"
                /></label>
                <span class="text-xs text-red-500" v-if="incorrectExternalNumberOnlyNumbers">
                  El campo solo acepta números.
                </span>
              </div>
              <div class="w-full">
                <label class="mb-2 mt-2">
                  Número interior:
                  <input
                    id="input_interior_number"
                    type="text"
                    v-model="interiorNumber"
                    class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                    maxlength="20"
                    minlength="2"
                    pattern="(S\/n)?(S/N)?([0-9-a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,20})?"
                    title="Número exterior debe tener un máximo de 20 caracteres, sin caracteres especiales."
                    oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
                    @blur="validityInternalNumber()"
                    @change="validityInternalNumber()"
                    @keyup="validityInternalNumber()"
                /></label>
                <span class="text-xs text-red-500 w-full" v-if="incorrectInternalNumberOnlyNumbersAndLetters">
                  El campo solo acepta letras y números.
                </span>
                <br>
              </div>
            </div>

            <div class="w-full">
              <label class=""> Código postal: </label>
              <input
                id="input_postal_code"
                type="text"
                v-model="postalCode"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                v-on:keyup="getAddress()"
                v-maska="'#####'"
                pattern="[0-9]{5,5}"
                title="Código postal debe tener 5 dígitos"
                maxlength="5"
                minlength="5"
                required
              />
              <loading
                 :height="15"
                 color="#fff"
                 class="static"
                 :active="isLoading"
                 loader="dots"
                 :can-cancel="true"
                 :is-full-page="false"
                />
              <span class="text-xs text-red-500 w-full" v-if="incorrectCP">
                Código postal debe tener 5 dígitos
              </span>
              <span
                class="text-xs text-red-500 w-full"
                v-if="postalCodeFound == false && postalCode != null"
              >
                No se encontró información del código postal
              </span>
            </div>
            <div class="w-full" v-if="postalCodeFound && !incorrectCP">
              <label class="w-full"> Colonia: </label>
              <v-select
              id="select_cologne"
              :searchable="false"
                v-model="selectedNeighborhood"
                class="appearance-none rounded text-grey-darker w-full shadow"
                :options="selectNeighborhoodOptions"
                :placeholder="'Seleccione una colonia'"
                :required="!selectedNeighborhood"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
              <span v-if="neighborhoodSelected" class="text-red-600 text-xs"
                >Seleccione una colonia</span
              >

              <div class="flex w-full">
                <div class="mt-1 mb-2 w-1/2 text-center">
                  <div class="">
                    <label class="w-full mb-2"> Municipio: </label>
                  </div>
                  <div class="">
                    <label class="w-full mb-2 text-gray-600">
                      {{ municipality ? municipality : "N/A" }}
                    </label>
                  </div>
                </div>

                <div class="mb-2 w-1/2 text-center">
                  <div>
                    <label class="w-full mt-1 mb-2"> Estado: </label>
                  </div>
                  <div class="">
                    <label class="w-full mb-2 text-gray-600">
                      {{ state ? state : "N/A" }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="flex w-full">
                <div class="mb-2 w-1/2 text-center">
                  <div class="">
                    <label class="w-full mb-2"> Ciudad: </label>
                  </div>

                  <div class="mb-2">
                    <label class="w-full mb-2 text-gray-600">
                      {{ city ? city : "N/A" }}
                    </label>
                  </div>
                </div>

                <div class="mb-2 w-1/2 text-center">
                  <div class="">
                    <label class="w-full mb-2"> País: </label>
                  </div>

                  <div class="">
                    <label class="w-full mb-2 text-gray-600">
                      {{ country }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full">
              <label class="mt-2"> Teléfono móvil: </label>
              <input
                id="input_mobile_phone"
                type="text"
                v-model="cellphone"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                v-maska="'###-###-####'"
                title="Debe tener 10 dígitos"
                maxlength="13"
                minlength="13"
                pattern="[0-9]{3}[-][0-9]{3}[-][0-9]{4}"
                required
              />
            </div>

            <div class="w-full">
              <label class="mt-2"> Correo electrónico: </label>
              <input
              id="input_email"
                v-model="email"
                type="email"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                required
                @keyup="validateEmail"
                oninput="this.value = this.value.toLowerCase();"
              />
              <span v-if="!isValidEmail" class="text-xs text-red-500 w-full">
                El correo no es válido
              </span>
            </div>
            <div class="hidden">
              <label class="w-full mt-5 mb-2"> Empresa: </label>
              <input
                type="text"
                v-model="company"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="50"
                minlength="1"
                pattern="[0-9-a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,50}"
                title="Colonia debe tener un máximo de 30 caracteres, sin caracteres especiales"
                oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
              />

              <label class="mt-5 mb-2"> Puesto: </label>
              <input
                type="text"
                v-model="job"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="50"
                minlength="1"
                pattern="[0-9-a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,50}"
                title="Puesto debe tener un máximo de 30 caracteres, sin caracteres especiales"
                oninput="this.value = this.value.toLowerCase().substr(0, 1).toUpperCase() + this.value.toLowerCase().substr(1, this.value.length);"
              />
            </div>

            <div class="">
              <label class="mt-2 w-full"> Fecha de Nacimiento: </label>
              <label class="w-full font-semibold ml-2">{{ birthday }}</label>
            </div>
          </div>
          <!-- CONTAINER 2 END-->
        </div>
        <!-- GRID END-->
        <div class="w-full p-2 text-center mt-5 mb-2">
          <button
            id="button_next"
            class="w-full d-flex justify-center items-center mx-auto md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded"
          >
            Siguiente <mdicon name="chevron-right" />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "@/assets/css/radioButton.css";
import Swal from "sweetalert2";
import Loading from 'vue-loading-overlay';
import { setPathNameToStorage } from '../helpers/pathName';
import { isApProductInStorage } from '../helpers/isApProductInStorage';
import { validate_name_with_rfc } from '../helpers/rfcValidations';

export default {
  name: "PersonalInformation",
  components: {Loading},
  data() {
    return {
      section: null,
      date: null,
      ccAPI: process.env.VUE_APP_CCAPI,
      token: null,
      kinship: null,
      policy: null,
      reference: null,
      rfc: null,
      age: 0,

      incorrectExternalNumber: false,
      incorrectExternalNumberOnlyNumbers: false,
      
      incorrectInternalNumber: false,
      incorrectInternalNumberOnlyNumbersAndLetters: false,

      incorrectRFC: null,
      incorrectRFCWithAge: false,
      incorrectRFCLenght: null,
      incorrectCP: false,
      paternalLastName: "",
      maternalLastName: "",
      name: "",
      gender: null,
      optionsGender: [
        { text: "Hombre", value: "Hombre" },
        { text: "Mujer", value: "Mujer" },
      ],
      status: null,
      optionsStatus: [
        { text: "Activo", value: "Activo" },
        { text: "Jubilado", value: "Jubilado" },
      ],
      base: null,
      optionsBase: [
        { text: "Transferido", value: "Transferido" },
        { text: "Telesecundaria", value: "Telesecundaria" },
        { text: "UPN", value: "UPN" },
      ],
      birthday: null,
      maritalStatus: null,
      maritalStatusVisible: true,
      street: null,
      interiorNumber: null,
      externalNumber: null,
      postalCode: null,
      postalCodeFound: null,
      neighborhood: [],
      selectedNeighborhood: [],
      selectStatus: [
        { label: "Activo", value: "Activo" },
        { label: "Jubilado", value: "Jubilado" },
      ],
      selectedStatus: null,
      selectBase28: [
        { label: "SEC Federal", value: "SEC Federal" },
        { label: "SEC Estatal", value: "SEC Estatal" },
        { label: "CEPES", value: "CEPES" },
        { label: "CONALEP", value: "CONALEP" },
        { label: "Homologado", value: "homologado" },
        { label: "ITESCA", value: "ITESCA" },
      ],
      selectBase54: [
        { label: "SEC Federal", value: "SEC Federal" },
        { label: "SEC Estatal", value: "SEC Estatal" },
        { label: "CEPES", value: "CEPES" },
        { label: "CONALEP", value: "CONALEP" },
        { label: "Homologado", value: "homologado" },
        { label: "ITESCA", value: "ITESCA" },
      ],
      selectBase26: [
        { label: "Transferido", value: "Transferido" },
        { label: "Telesecundaria", value: "Telesecundaria" },
        { label: "UPN", value: "UPN" },
      ],
      selectBase2: [
        { label: "ISEP", value: "ISEP" },
        { label: "SEIT", value: "SEIT" },
        { label: "Jub. Descentralizados", value: "Jub. Descentralizados" },
        { label: "Jubilados", value: "Jubilados" },
      ],
      selectBase37: [
        {
          label: "Magisterio Sección 37 (k4)",
          value: "Magisterio Sección 37 (k4)",
        },
      ],
      selectedBase: null,
      errorBase: false,
      selectRetirement_type: [
        { label: "Jubilado", value: "Jubilado" },
        { label: "Pensionado", value: "Pensionado" },
      ],

      selectedRetirement_type: null,
      delegation: null,
      errorStatus: false,
      errorGender: false,
      errorMaritalStatus: false,
      pension_number: null,
      errorNeighborhood: false,
      municipality: null,
      city: null,
      state: null,
      country: null,
      company: null,
      job: null,
      cellphone: null,
      payment_type: null,
      email: null,
      isValidEmail: true,
      isLoading: false,
      optionsMaritalStatus: [
        { text: "Soltero(a)", value: "Soltero(a)" },
        { text: "Casado(a)", value: "Casado(a)" },
        { text: "Viudo(a)", value: "Viudo(a)" },
      ],
      optionsMaritalStatus2: [
        { text: "Divorciado(a)", value: "Divorciado(a)" },
        { text: "Concubinato", value: "Concubinato" },
      ],
    };
  },
  created() {
    this.getDataFromLocalStore();
    this.getMaritalStatus();
  },
  mounted(){
    this.setFormValuesFromStorage()
    this.getClientDataStorage();
    this.$refs.rfc.focus();
    //this.disableInputsWhenClientExist();
   
  },
  methods: {

    isValidTextLength(text){
        return text.length >= 1
    },
    validateRFCWithNames(){
      if(!this.isValidTextLength(this.rfc)){
        return;
      }
      if(!this.isValidTextLength(this.name)){
        return;
      }
      //validateExistenceOnLastName(this.maternalLastName, this.paternalLastName);
      
      
      const resp = validate_name_with_rfc(this.rfc, this.name, this.paternalLastName, this.maternalLastName);
      console.log("resp; ", resp)
      if(!resp){
        Swal.fire({
            icon: 'warning',
            text: 'RFC no coincide con Nombre',
            buttonConfirmText: 'ok'
        })
      }
      return resp;
    },
    disableInputsWhenClientExist(){
      const rfc_client = localStorage.getItem("rfc_client") || null;
      if(rfc_client != null){
        this.$refs.rfc.disabled = true;
        this.$refs.paternalLastName.disabled = true;
        this.$refs.maternalLastName.disabled = true;
        this.$refs.name.disabled = true;
      }

      
    },
    getItemFromLocalStorage(item){
      return localStorage.getItem(item) || '{}';
    },
    validateAgeWithRFC(age){
      
      const ageStorage = Number(this.getItemFromLocalStorage("age"));
      const kinship = this.getItemFromLocalStorage("kinship");
      if(kinship === "Titular"){
        if(isNaN(ageStorage)){
          this.incorrectRFCWithAge = false;
          return;
        }
        if(ageStorage !== age){
          Swal.fire({
            icon: 'warning',
            text: 'RFC no coincide con edad ingresada en cotización',
            buttonConfirmText: 'ok'
          })
          return false;

          //this.rfc = '';
        }
      }
      return true;

    },
    validateEmail(){
      const resp =  new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(this.email);
      this.isValidEmail = resp;
      return resp;
    },
    getClientDataStorage(){
      if(localStorage.getItem("data_client") === null){
        return false;
      }
      const dataClient =  JSON.parse(localStorage.getItem("data_client"));
      this.rfc = dataClient.rfc;
      this.paternalLastName = dataClient.paternal_name,
      this.maternalLastName = dataClient.maternal_name,
      this.name = dataClient.names,
      this.validityRFC();

    },
    setFormValuesFromStorage(){
    const policy_client = JSON.parse(localStorage.getItem("policy"))?.client;
    if(!policy_client){
      return;
    }
    console.log("policy: ", policy_client)
    const maritalStatus = localStorage.getItem("maritalStatus");

    this.rfc = policy_client.rfc;
    this.paternalLastName = policy_client.paternal_lastname;
    this.maternalLastName = policy_client.maternal_lastname;
    this.name = policy_client.first_name.length > 1 ? policy_client.first_name +' '+ policy_client.second_name : '';
    this.status = policy_client.workplace.status;
    this.selectedBase = {
      label: policy_client.workplace.base,
      value: policy_client.workplace.base
    } 
    if(policy_client.gender.length > 0){
      this.gender = policy_client.gender === "H" ? "Hombre" : "Mujer";
    }
    this.street = policy_client.street;
    this.externalNumber = policy_client.exterior_number;
    this.interiorNumber = policy_client.interior_number;
    this.postalCode = policy_client.zip_code;
    this.cellphone =policy_client.lada_cellphone + policy_client.cellphone_number;
    this.maritalStatus = maritalStatus;
    this.selectedNeighborhood = {
      label: policy_client.neighborhood,
      value: policy_client.neighborhood_value
      };
    this.email = policy_client.emails.toLowerCase();
    this.validityRFC();
    this.getAddress();
    },
    toUpperCase(){
      this.rfc = this.rfc.toUpperCase()
    },
    setRFCStorage(rfc){
      localStorage.setItem("rfc_applicant", rfc)
    },
    //for all words
    /* toCapitalizeFirstLetter(e){
      let str = e.target.value.toLowerCase();
      e.target.value = str.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    }, */
    getDataFromLocalStore() {
      this.kinship = localStorage.kinship;
      this.section = localStorage.sectionDescription;
      this.payment_type = localStorage.payment_type;
    },
    getMaritalStatus() {
      if (this.kinship != "Titular") {
        this.maritalStatus = localStorage.maritalStatus;
        this.maritalStatusVisible = false;
      } else {
        //this.maritalStatus = "Soltero(a)";
        this.maritalStatusVisible = true;
      }
    },
    async validityRFC() {
      console.log("change; ", this.rfc);
      /*if (!isNaN(this.rfc.substr(4, 6))) {
        var m = this.rfc.match(/^\w{4}(\w{2})(\w{2})(\w{2})/);
        var anyo = parseInt(m[1], 10) + 1900;
        if (anyo < 1950) anyo += 100;
        var mes = parseInt(m[2], 10) - 1;
        var dia = parseInt(m[3], 10);
        var newDate = new Date(anyo, mes, dia);
        moment.locale("es");
        //var dateFormat = moment(newDate).format("DD [de] MMMM [de] YYYY");
        var dateFormatt = moment(newDate).format("DD/MM/YYYY");
        //this.birthday = dateFormat;
        this.date = dateFormatt;
        localStorage.setItem("birthdayOwner", this.date);
        console.log("DATE ", this.date);
      } else {
        this.incorrectRFC = true;
        this.birthday = null;
      }*/
      if (this.rfc != null && this.rfc.length == 13) {
        this.setRFCStorage(this.rfc)
        await this.login();
        this.getDateByRFC(this.rfc);
        this.incorrectRFC = false;
        this.incorrectRFCLenght = false;
        this.validateRFCWithNames();

        
      }
    },
    async validityExternalNumber() {
      this.incorrectExternalNumber = false;
      this.incorrectExternalNumberOnlyNumbers = false;
      if (this.externalNumber != "" && !new RegExp('^[0-9]+$').test(this.externalNumber)) {
        this.incorrectExternalNumber = true;
        this.incorrectExternalNumberOnlyNumbers = true;
      }
    },
    async validityInternalNumber() {
      this.incorrectInternalNumber = false;
      this.incorrectInternalNumberOnlyNumbersAndLetters = false;
      if (this.interiorNumber != "" && !new RegExp('^[0-9a-zA-Z]+$').test(this.interiorNumber)) {
        this.incorrectInternalNumber = true;
        this.incorrectInternalNumberOnlyNumbersAndLetters = true;
      }
    },
    validateRFCLength(){
      if (this.rfc.length < 13 || this.rfc.length > 13) {
        this.incorrectRFCLenght = true;
        this.validateRFCWithNames()
      }
    },
    /* getInformationByRFC(rfc){
       axios.get(`${this.ccAPI}lm/accidents_and_illnesses/get_by_rfc/`,{ params: { "rfc": rfc } })
        .then((data) => {
            let response = data.data.response;
            this.paternalLastName =  response.paternal_name;
            this.maternalLastName =  response.maternal_name;
            this.name =  response.names;
            var dateFormat = moment(response.birthday).format("DD [de] MMMM [de] YYYY");
            this.birthday = dateFormat;
            this.incorrectRFC = false;
        })
        .catch(()=>{
              this.cleaPersonalInformation();
              this.login();
              this.getDateByRFC(rfc);
          }
        )
    },
    cleaPersonalInformation(){
      this.paternalLastName = "";
      this.maternalLastName = "";
      this.name = "";
    }, */
    getDateByRFC(rfc){
      
      axios.get(this.ccAPI + "rfc_is_valid", {
            params: {
              rfc,
              token_auth: this.token,
            },
          })
          .then(() => {
            this.setBirth();
            this.incorrectRFC = false;
            
          })
          .catch((error) => {
            console.log("Error al validar el RFC: ", error);
            //this.birthday = "";
            this.incorrectRFC = true;
          });
     
    },
    async setBirth() {
      //await this.login();
      axios
        .get(this.ccAPI + "get_date_by_rfc", {
          params: {
            rfc: this.rfc,
            token_auth: this.token,
          },
        })
        .then((response) => {
          moment.locale("es");
          var dateFormat = moment(response.data.response.date).format(
            "DD [de] MMMM [de] YYYY"
          );
          this.birthday = dateFormat;
          var dateFormatt = moment(response.data.response.date).format("DD/MM/YYYY");
          this.birthday = dateFormat;
          this.date = dateFormatt;

          let currentDate = moment();
          this.age = moment(response.data.response.date, 'YYYY-MM-DD').diff(currentDate, 'years') * -1;
          console.log("ThisAge: ", this.age);
          this.validateAgeWithRFC(this.age);
          localStorage.setItem("birthdayOwner", this.date);
          this.incorrectRFC = false;
        })
        .catch((error) => {
          console.log("Error al validar la fecha de nacimiento: ", error);
          this.birthday = "";
          this.incorrectRFC = true;
        });
    },
    async login() {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        user: {
          password: "cabsa2022",
          email: "aplm@gcabsa.com.mx",
        },
      };
      await axios
        .post(this.ccAPI + "fas/login", data, config)
        .then((response) => {
          this.token = response.data.token_auth;
          //localStorage.setItem("token_auth_valid", this.token_auth_valid);
        });
    },
    getAddress() {
      if (this.postalCode.length > 2) {
        this.isLoading = true;
        if (this.postalCode != null && this.postalCode.length == 5) {
          this.incorrectCP = false;
          axios
            .post(
              "https://anter.com.mx:3001/Api/Catalogo/Sepomex/obtener_colonias",
              {
                contenido: {
                  codigo_postal: this.postalCode,
                },
                accion: "consultarColoniasPorCP",
              },
              {
                auth: {
                  username: "multicr",
                  password: "*cabsa2018*",
                },
              }
            )
            .then((response) => {
              this.postalCodeFound = true;
              this.city = response.data.ciudad.nombre;
              this.state = response.data.estado.nombre;
              this.municipality = response.data.municipio.nombre;
              this.country = "México";
              this.neighborhood = response.data.colonias;
            })
            .catch((error) => {
              console.log("Se presento un error: ", error);
              this.postalCodeFound = false;
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.incorrectCP = true;
          this.selectedNeighborhood = "";
        }
      } else {
        this.isLoading = false;
      }
    },
    onSubmit() {
      if(this.incorrectExternalNumber || this.incorrectInternalNumber){
        return;
      }
      if (this.status == null) {
        this.errorStatus = true;
        return;
      } else {
        this.errorStatus = false;
      }
      if (this.selectedBase == null || this.selectedBase.label == undefined) {
        this.errorBase = true;
        return;
      } else {
        this.errorBase = false;
      }
      if (this.gender == null) {
        this.errorGender = true;
        return;
      } else {
        this.errorGender = false;
      }
      if (this.maritalStatusVisible == true && this.maritalStatus == "") {
        this.errorMaritalStatus = true;
        return;
      } else {
        this.errorMaritalStatus = false;
      }
      if(!this.validateAgeWithRFC(this.age)){
        return;
      }
      if(!this.validateRFCWithNames()){
        return;
      }

      let ageDepEcoFather = localStorage.age;
      let nacimiento = moment(this.date, "DD/MM/YYYY");
      let hoy = moment();
      let ageTitular = hoy.diff(nacimiento, "years");
      if (this.kinship == "Padres") {
        if (ageTitular > ageDepEcoFather) {
          Swal.fire(
            "Edad no admitida",
            "La edad del Titular no debe ser mayor a la del dependiente económico padre.",
            "info"
          );
          return;
        }
      }
      if (this.selectedNeighborhood.value > 0) {
        if (this.getPolicyFromLocalStorage()) {
          this.addPersonalInfoModel(this.policy);
        } else {
          Swal.fire(
            "Error",
            "Se presentó un error, no fue posible cargar los datos. Favor de contactar a sistemas.",
            "error"
          );
          this.$router.push({ name: "home" });
        }
        const selected_products = JSON.parse(this.getItemFromLocalStorage("policy"))?.client?.selected_products;
        if(this.kinship != "Titular"){
          setPathNameToStorage("pathname", "economic-dependent")
          this.$router.push({ name: "economic-dependent" });
          return;
        }
        if (isApProductInStorage(selected_products.details)) {
          setPathNameToStorage("pathname", "add-ap-beneficiary")
          this.$router.push({ name: "add-ap-beneficiary" });
        } else {
          setPathNameToStorage("pathname", "personal-information")

          this.$router.push({ name: "carga-identificacion" });
        }
      } else {
        this.errorNeighborhood = true;
      }
    },
    
    getPolicyFromLocalStorage() {
      this.policy = JSON.parse(localStorage.getItem("policy"));
      return !!this.policy;
    },
    addPersonalInfoModel(policy) {
      policy.client.rfc = this.rfc;
      policy.client.paternal_lastname = this.paternalLastName;
      policy.client.maternal_lastname = this.maternalLastName;
      let array = this.name?.trim().split(" ");
      /* for (var i = 1; i < array.length; i++) {
        secondName += array[i].replace(/^\w/, (c) => c.toUpperCase()) + " ";
      } */
      policy.client.first_name = array[0].trim();
      policy.client.second_name = array[1] === undefined ? '' :array[1].trim();
      policy.client.gender = this.gender == "Hombre" ? "H" : "M";
      policy.client.date_birth = this.date;
      policy.client.street = this.street;
      policy.client.exterior_number = this.externalNumber;
      policy.client.interior_number = this.interiorNumber;
      policy.client.zip_code = this.postalCode;
      policy.client.marital_status = this.maritalStatus;
      policy.client.neighborhood = this.selectedNeighborhood.label;
      policy.client.neighborhood_value = this.selectedNeighborhood.value;
      policy.client.municipality = this.municipality;
      policy.client.city = this.city == null ? "N/A" : this.city;
      policy.client.state = this.state;
      policy.client.country = this.country;
      policy.client.company_name = "SNTE"; //this.company;
      policy.client.job = "Trabajador de la Educación"; //this.job;
      let partsCel = this.cellphone.split("-");
      policy.client.lada_cellphone = partsCel[0];
      policy.client.cellphone_number = partsCel[1] + partsCel[2];
      policy.client.emails = this.email; /*[this.email];*/
      let workplace = {};
      workplace.pension_number = this.pension_number;
      workplace.delegation = this.delegation;
      workplace.status = this.status; //this.selectedStatus.label;
      workplace.base = this.selectedBase.label;
      workplace.retirement_type = ""; //this.selectedRetirement_type.label
      workplace.payment_type = this.payment_type;
      policy.client.workplace = workplace;
      localStorage.setItem("policy", JSON.stringify(policy));
      localStorage.setItem("maritalStatus", this.maritalStatus);
    },
    validateInfo() {},
    saveInLocalStorage() {},
  },
  computed: {
    selectBase() {
      switch (this.section) {
        case "Seccion 26":
          return [
            { label: "Transferido", value: "Transferido" },
            { label: "Telesecundaria", value: "Telesecundaria" },
            { label: "UPN", value: "UPN" },
          ];
        case "Seccion 2":
        
          return [
            { label: "ISEP", value: "ISEP" },
            { label: "SEIT", value: "SEIT" },
            { label: "Jub. Descentralizados", value: "Jub. Descentralizados" },
            { label: "Jubilados", value: "Jubilados" },
          ];
        case "Seccion 37":
          return [
            {
              label: "Magisterio Sección 37 (k4)",
              value: "Magisterio Sección 37 (k4)",
            },
          ];
        default:
          return [
            { label: "SEC Federal", value: "SEC Federal" },
            { label: "SEC Estatal", value: "SEC Estatal" },
            { label: "CEPES", value: "CEPES" },
            { label: "CONALEP", value: "CONALEP" },
            { label: "Homologado", value: "homologado" },
            { label: "ITESCA", value: "ITESCA" },
          ];
      }
    },
    neighborhoodSelected() {
      if (
        this.selectedNeighborhood.value > 0 &&
        this.errorNeighborhood == true
      ) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.errorNeighborhood = false;
        return this.errorNeighborhood;
      }
      return this.errorNeighborhood;
    },
    selectNeighborhoodOptions() {
      return this.neighborhood.map((neighborhood) => ({
        label: neighborhood.nombre,
        value: neighborhood.id,
      }));
    },
    statusSelected: function () {
      if (this.errorStatus) {
        return true;
      }
      return false;
    },
    baseSelected: function () {
      if (this.errorBase) {
        return true;
      }
      return false;
    },
    genderSelected: function () {
      if (this.errorGender) {
        return true;
      }
      return false;
    },
    maritalStatusSelected: function () {
      if (this.errorMaritalStatus) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}
</style>